import { StylistService } from 'src/app/services';
import { Component, ViewChild, OnInit, Input, OnDestroy } from '@angular/core';
import {
  IonInfiniteScroll,
  ModalController,
  NavController,
} from '@ionic/angular';

import {
  Booking,
  Client,
  Stylist,
  ServiceDefinition,
  Service,
} from '../../../models';
import { UserService } from '../../../services/user.service';
import { CalendarService } from '../../../services/calendar.service';
import { StylistPickerComponent } from '../../../components/stylist-picker/stylist-picker.component';
import { List } from 'immutable';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';

import { ClientFormPageComponent } from '../../../components/client-form-page/client-form-page.component';
import { ClientPickerComponent } from '../../../components/smr-client-picker/smr-client-picker.component';

import { BookingFormActionType } from '../shared/booking-form-action-type';
import { NavigationStateService } from '../../../services/navigation-state.service';
export interface IStylistPickerInit {
  success: boolean;
  stylist: Stylist;
}

export interface IClientFormCallBackData {
  client: Client;
  action: string;
}

@Component({
  selector: 'smr-booking-form-client-list',
  templateUrl: './booking-form-client-list.page.html',
  styleUrls: ['./booking-form-client-list.page.scss'],
})
export class BookingFormClientListPage implements OnInit, OnDestroy {
  @ViewChild(ClientPickerComponent)
  clientPickerComponent: ClientPickerComponent;

  @ViewChild(StylistPickerComponent)
  stylistPickerComponent: StylistPickerComponent;

  private booking: Booking;

  private actionType;

  public stylist: Stylist;

  public isLoadingStylists: boolean;

  public errorOccurredWhileLoadingStylists: boolean;

  public readOnlyStylistPicker: boolean;

  private infiniteScrollMonitor = new Subject<IonInfiniteScroll>();

  private infiniteScrollMonitor$ = this.infiniteScrollMonitor.asObservable();

  public clientListFullyLoaded: boolean;

  public stylistCol: number;

  public rootUrl: string = '/bookings';

  public navigationStateSubscription;

  constructor(
    private navCtrl: NavController,
    private modalCtrl: ModalController,
    private calendarService: CalendarService,
    private userService: UserService,
    private stylistService: StylistService,
    private router: Router,
    private navigationStateService: NavigationStateService
  ) {
    this.navigationStateSubscription = this.navigationStateService.getState().subscribe((state) => {
      this.booking = state.booking;
      this.actionType = state.actionType;
      this.stylist = this.calendarService.getBookingCalendarViewStylist();
      if (this.stylist) {
        this.stylistCol = this.stylist.getID();
      } else {
        this.stylistCol = state.stylistID;
        this.stylistService
          .loadStylistInfo(this.stylistCol)
          .subscribe((stylist) => (this.stylist = stylist));
      }
      if (
        this.userService.getUser().isAdministrator() ||
        this.userService.getUser().getViewAllCalendars() === 1 ||
        this.userService.getUser().getViewAllClients() === 1
      ) {
        this.readOnlyStylistPicker = false;
      } else {
        this.readOnlyStylistPicker = true;
      }
    });
  }

  public ngOnInit() {
    if (this.actionType == BookingFormActionType.AddWaitListBooking)
      this.rootUrl = '/waitlist';
  }

  public ngOnDestroy() {
    this.navigationStateSubscription.unsubscribe();
  }

  public onStylistPickerInit($event: IStylistPickerInit) {
    if ($event.success) {
      // this.stylist = $event.stylist;
      this.isLoadingStylists = false;
    } else {
      this.isLoadingStylists = false;
      this.errorOccurredWhileLoadingStylists = true;
    }
  }

  public onRetry() {
    this.isLoadingStylists = true;
    this.errorOccurredWhileLoadingStylists = false;
    this.stylistPickerComponent.ngOnInit();
  }

  public onStylistSelect($event: Stylist) {
    this.stylist = $event;
    this.calendarService.setBookingCalendarViewStylist(this.stylist);
  }

  public async onClientSelect(client: Client) {
    this.booking = this.booking.setClient(client);

    this.navigationStateService.setState({
      booking: this.booking,
      actionType: this.actionType,
      stylistCol: this.stylistCol,
    })

    this.router.navigate(
      ['/bookings/booking-form-service-list-page']
    );
  }

  public async onClientAdd() {
    let client: Client = new Client();
    client = client.setStylistID(this.userService.getUser().getID());

    const clientFormModal = await this.modalCtrl.create({
      component: ClientFormPageComponent,
      componentProps: {
        client: client,
        modal: true,
        saveButtonText: 'Save & Continue',
      },
    });

    clientFormModal.present();

    clientFormModal.onDidDismiss().then((data: any) => {
      if (data.data) {
        this.clientPickerComponent.addClient(data.data.client);
        this.onClientSelect(data.data.client);
      }
    });
  }

  public onCreateTimeOff() {
    // create a service with a type of 'timeoff' here
    const bookingOptions = {
      id: undefined,
      salonID: this.booking.getSalonID(),
      startDateTime: this.booking.getStartDateTime(),
      endDateTime: undefined,
      client: undefined,
      status: 3,
      services: List([]),
      recurring: undefined,
      reminderSent: undefined,
      creationDate: new Date(),
      sendEmail: 0,
      type: 'timeoff',
      photos: List([]),
      beforePhotos: List([]),
      afterPhotos: List([]),
    };

    // create a new booking
    let booking: Booking = new Booking(bookingOptions);

    booking = booking.addService(
      new Service({
        id: undefined,
        bookingGroupID: undefined,
        stylistID: this.stylist.getID(),
        clientID: undefined,
        client: undefined,
        name: undefined,
        price: 0.0,
        quantity: 1,
        isRefund: 0,
        taxRateType: 0,
        stylist: this.stylist,
        type: 'timeoff',
        lineItemID: undefined,
        serviceDefinition: new ServiceDefinition({
          duration: 15,
          processDuration: 0,
          finishDuration: 0,
          stylist: this.stylist,
          description: undefined,
          startingAt: undefined,
          categoryID: undefined,
          parentID: undefined,
          id: undefined,
          name: undefined,
          price: undefined,
          clientBookable: undefined,
          serviceCategory: undefined,
        }),
        clientNotes: '',
        stylistNotes: '',
        startDateTime: this.booking.getStartDateTime(),
        durations: {
          startDuration: 15,
          processDuration: 0,
          finishDuration: 0,
        },
        isPhantom: true,
        discount: undefined,
        customTaxes: undefined,
      })
    );

    this.navigationStateService.setState({
      booking: booking,
    })

    this.router.navigate(['/bookings/booking-form-time-off']);
  }

  public goBackToCalendar() {
    this.router.navigateByUrl('/bookings');
  }

  // public onBack () {
  //   this.navCtrl.setDirection('back');
  //   if(this.actionType == BookingFormActionType.AddWaitListBooking){
  //     this.router.navigateByUrl('/waitlist')
  //   }
  //   else {
  //     this.router.navigateByUrl('/bookings')
  //   }
  // }

  public onInfiniteScroll($event: IonInfiniteScroll) {
    // this.infiniteScrollMonitor.next($event);
  }

  public onClientListLoad($event: List<Client>) {
    this.clientListFullyLoaded = $event.count() < 30;
  }
}
